// Shared WeakMap to associate temporary local IDs with File/UploadedFileAsset objects
const localIdMap: WeakMap<object, string> = new WeakMap();

export default localIdMap;
